import { Link } from 'react-router-dom';
import { TABS } from '@constants/common.constants';
import { TRANSACTION_CATEGORY } from '@constants/transaction.constants';
import { QUERY_PARAMS, ROUTES } from '@constants/route.constant';
import { ITransactions, ITransaction } from '@interfaces/transaction';
import { IRedemption } from '@interfaces/redemption';
import Transactions from './Transactions';

interface HomeTabProps {
	selectedTab: string;
	transactionsData: {
		transactions: ITransactions<ITransaction>[];
		isLoading: boolean;
		isRefreshing: boolean;
	};
	redemptionData: {
		transactions: ITransactions<IRedemption>[];
		isLoading: boolean;
		isRefreshing: boolean;
	};
}

export default function HomeTabContent({ selectedTab, transactionsData, redemptionData }: HomeTabProps) {
	const shouldShowTransactionsSkeleton = transactionsData.isLoading && transactionsData.transactions.length === 0 && !transactionsData.isRefreshing;
	const shouldShowRedemptionsSkeleton = redemptionData.isLoading && redemptionData.transactions.length === 0 && !redemptionData.isRefreshing;

	return (
		<>
			{selectedTab === TABS.PAYMENTS ? (
				<>
					<Transactions
						transactions={transactionsData.transactions}
						isLoading={shouldShowTransactionsSkeleton}
						category={TRANSACTION_CATEGORY.TRANSACTION}
					/>
				</>
			) : (
				<Transactions transactions={redemptionData.transactions} isLoading={shouldShowRedemptionsSkeleton} category={TRANSACTION_CATEGORY.REDEMPTION} />
			)}
			<div className='container flex justify-center'>
				<button className='bg-white mb-8 w-[327px] rounded-full border-2 border-cyan text-cyan font-semibold tablet:text-xl py-2.5 cursor-pointer z-10'>
					<Link to={`/${ROUTES.TRANSACTIONS}?${QUERY_PARAMS.TAB}=${selectedTab}`}>View Past Transactions</Link>
				</button>
			</div>
		</>
	);
}
